import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { Header, Sidebar } from '../../organisms';
import { FloatingChat } from '../../organisms/FloatingChat';

const LayoutContainer = styled.div`
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const MainContainer = styled.div`
  display: flex;
`;

const ContentArea = styled.main`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
`;

const DashboardLayout = () => {
  return (
    <LayoutContainer>
      <Header />
      <MainContainer>
        <Sidebar />
        <ContentArea>
          <Outlet />
        </ContentArea>
      </MainContainer>
      <FloatingChat />
    </LayoutContainer>
  );
};

export default DashboardLayout;
